import $ from "jquery";
import { getRGBFromHex } from "./utilities";

// Interval for pieGraph animations in milliseconds
const drawInterval = 33.333;

// Allow access to graph widths outside of functions
let pieGraphContainerWidth;
let barGraphContainerWidth;

// Controlling state of pie graphs
let animateStocks = true;
let animateSectors = true;

let currentlyAnimating = false;

// Creating canvas objects to exist outside of function
let canadianStocksPieCanvas;
let worldStocksPieCanvas;
let canadianSectorsPieCanvas;
let worldSectorsPieCanvas;

// Draw the pie sector
function drawSector(ctx, centerX, centerY, radius, startAngle, endAngle, anticlockwise, colour) {
    ctx.save();
    ctx.fillStyle = colour;
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.arc(centerX, centerY, radius, startAngle, endAngle, anticlockwise);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
}

// Draw the pie donut and the pie slice
function drawPieGraph(
    ctx,
    donutCenterX,
    donutCenterY,
    sliceCenterX,
    sliceCenterY,
    startAngle,
    endAngle,
    donutColour,
    sliceColour,
    canvas,
    alternateRadius,
) {
    $(".pie-graph-container").css({
        "width": "200px",
        "height": "200px",
    });
    // console.log(canvas.parentNode.clientWidth);
    canvas.height = 200;
    canvas.width = 200;
    const anglePadding = (1 * Math.PI) / 180;
    const sliceRadius = (canvas.width / 2) * 0.7;
    const outerCircleRadius = alternateRadius ? alternateRadius : sliceRadius * 0.9;
    const innerCircleRadius = outerCircleRadius * 0.6;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw the slice
    drawSector(
        ctx,
        sliceCenterX,
        sliceCenterY,
        sliceRadius,
        startAngle + anglePadding,
        endAngle - anglePadding,
        false,
        sliceColour,
    );

    // Draw the inner circle of the slice
    drawSector(
        ctx,
        sliceCenterX,
        sliceCenterY,
        innerCircleRadius,
        startAngle - anglePadding,
        endAngle + anglePadding,
        false,
        "#ffffff",
    );

    // Draw the outer circle of the donut
    drawSector(
        ctx,
        donutCenterX,
        donutCenterY,
        outerCircleRadius,
        startAngle - anglePadding,
        endAngle + anglePadding,
        true,
        donutColour,
    );

    // Draw the inner circle of the donut
    drawSector(
        ctx,
        donutCenterX,
        donutCenterY,
        innerCircleRadius,
        startAngle + anglePadding,
        endAngle - anglePadding,
        true,
        "#ffffff",
    );

    // Draw the inner circle
    drawSector(ctx, donutCenterX, donutCenterY, innerCircleRadius, 0 * Math.PI, 2 * Math.PI, false, "#ffffff");
}

// Build simple pie graphs for diversification in canvas
export function buildPieGraph(
    stats,
    canvas,
    donutColour,
    sliceColour,
    animate,
    // bounceInDegrees,
    grow,
    hover,
) {
    // Sizes and customizations for pie and pie slice, convert degrees to radians
    let startAngle = (270 * Math.PI) / 180;
    let endAngle = startAngle + (stats / 100) * (2 * Math.PI);

    $(".pie-graph-container").css({
        "width": "200px",
        "height": "200px",
    });

    // canvas.height = canvas.parentNode.clientWidth;
    // canvas.width = canvas.parentNode.clientWidth;
    canvas.height = 200;
    canvas.width = 200;
    const ctx = canvas.getContext("2d");
    const centerX = canvas.height / 2;
    const centerY = canvas.width / 2;
    const pieSliceRadius = (canvas.width / 2) * 0.7;
    const pieOuterRadius = pieSliceRadius * 0.9;

    const hoverTag = canvas.previousElementSibling;

    let time = performance.now();

    // To use pie animations, figure out these options
    const pieOptions = {
        canvas,
        ctx,
        centerX,
        centerY,
        time,
        donutColour,
        sliceColour,
        growthRadius: pieSliceRadius, // radius of pie before bounce back
        pieRadius: pieOuterRadius, // final radius of pie after bounce back
        pieSliceRadius, // radius of slice
        startAngle,
        endAngle,
        grow, // amount that the pie will grow/shrink, in pixels
    };

    if (animate) {
        // Only call animation function if pie hasn't been animated before
        animatePie(pieOptions);
    } else if (hover === "mouseenter") {
        drawPieGraph(ctx, centerX, centerY, centerX, centerY, startAngle, endAngle, donutColour, sliceColour, canvas);
        growPieGraph(pieOptions);
        hoverTag.style.display = "block";
    } else if (hover === "mouseleave") {
        const shrinkArea = Math.abs(grow);
        const shrinkAngle = (endAngle - startAngle) / 2;
        const largeAngle = startAngle + shrinkAngle;
        const smallAngle = shrinkAngle < Math.PI / 2 ? Math.PI / 2 - shrinkAngle : shrinkAngle - Math.PI / 2;
        const shrinkXArea = shrinkArea * Math.cos(smallAngle);
        const shrinkYArea = shrinkArea * Math.sin(smallAngle);
        const newCenterX = centerX + shrinkXArea;
        const newCenterY = largeAngle < 2 * Math.PI ? centerY - shrinkYArea : centerY + shrinkYArea;
        hoverTag.style.display = "none";
        drawPieGraph(
            ctx,
            centerX,
            centerY,
            newCenterX,
            newCenterY,
            startAngle,
            endAngle,
            donutColour,
            sliceColour,
            canvas,
        );
        shrinkPieGraph(pieOptions);
    } else {
        drawPieGraph(ctx, centerX, centerY, centerX, centerY, startAngle, endAngle, donutColour, sliceColour, canvas);
    }
}

// Beginning of animation - it chains subsequent animations once it's done
function animatePie(pieOptions) {
    currentlyAnimating = true;
    let donutOpacity = 0;
    let opacityIncrement = 1 / (drawInterval * 0.3);
    const donutColour = getRGBFromHex(pieOptions.donutColour);
    const sliceColour = getRGBFromHex(pieOptions.sliceColour);

    const fadeInPieAnimation = () => {
        if (donutOpacity <= 1) {
            window.requestAnimationFrame(fadeInPieAnimation);
            if (performance.now() > pieOptions.time + drawInterval) {
                donutOpacity += opacityIncrement;
                drawPieGraph(
                    pieOptions.ctx,
                    pieOptions.centerX,
                    pieOptions.centerY,
                    pieOptions.centerX,
                    pieOptions.centerY,
                    pieOptions.startAngle,
                    pieOptions.endAngle,
                    `rgba(${donutColour[0]},${donutColour[1]},${donutColour[2]},${donutOpacity.toString()})`,
                    `rgba(${sliceColour[0]},${sliceColour[1]},${sliceColour[2]},0)`,
                    pieOptions.canvas,
                );
                pieOptions.time += drawInterval;
            }
        } else {
            fadeInSlice(pieOptions);
        }
    };

    window.requestAnimationFrame(fadeInPieAnimation);
}

function fadeInSlice(pieOptions) {
    let sliceOpacity = 0;
    let opacityIncrement = 1 / (drawInterval * 0.3);
    const donutColour = getRGBFromHex(pieOptions.donutColour);
    const sliceColour = getRGBFromHex(pieOptions.sliceColour);

    const fadeInSliceAnimation = () => {
        if (sliceOpacity <= 1) {
            window.requestAnimationFrame(fadeInSliceAnimation);
            if (performance.now() > pieOptions.time + drawInterval) {
                sliceOpacity += opacityIncrement;
                drawPieGraph(
                    pieOptions.ctx,
                    pieOptions.centerX,
                    pieOptions.centerY,
                    pieOptions.centerX,
                    pieOptions.centerY,
                    pieOptions.startAngle,
                    pieOptions.endAngle,
                    `rgba(${donutColour[0]},${donutColour[1]},${donutColour[2]},1)`,
                    `rgba(${sliceColour[0]},${sliceColour[1]},${sliceColour[2]},${sliceOpacity.toString()})`,
                    pieOptions.canvas,
                );
                pieOptions.time += drawInterval;
            }
        } else {
            currentlyAnimating = false;
        }
    };

    window.requestAnimationFrame(fadeInSliceAnimation);
}

// Strictly for hover animation - only growth without the fade in
function growPieGraph(pieOptions) {
    const growArea = Math.abs(pieOptions.grow); // Revert given value if negative
    const growAngle = (pieOptions.endAngle - pieOptions.startAngle) / 2;
    const largeAngle = pieOptions.startAngle + growAngle;
    const smallAngle = growAngle < Math.PI / 2 ? Math.PI / 2 - growAngle : growAngle - Math.PI / 2;
    const growXArea = growArea * Math.cos(smallAngle);
    const growYArea = growArea * Math.sin(smallAngle);
    const growXIncrement = growXArea / (drawInterval * 0.1); // tenth of a second
    const growYIncrement = growYArea / (drawInterval * 0.1); // tenth of a second

    let newCenterX = pieOptions.centerX;
    let newCenterY = pieOptions.centerY;

    const growPieGraphAnimation = () => {
        const currentDistance = Math.sqrt(
            (newCenterX - pieOptions.centerX) ** 2 + (newCenterY - pieOptions.centerY) ** 2,
        );

        if (currentDistance < growArea) {
            window.requestAnimationFrame(growPieGraphAnimation);

            if (performance.now() > pieOptions.time + drawInterval) {
                newCenterX += growXIncrement;
                newCenterY += largeAngle < 2 * Math.PI ? -growYIncrement : growYIncrement;
                drawPieGraph(
                    pieOptions.ctx,
                    pieOptions.centerX,
                    pieOptions.centerY,
                    newCenterX,
                    newCenterY,
                    pieOptions.startAngle,
                    pieOptions.endAngle,
                    pieOptions.donutColour,
                    pieOptions.sliceColour,
                    pieOptions.canvas,
                );
                pieOptions.time += drawInterval;
            }
        }
    };

    window.requestAnimationFrame(growPieGraphAnimation);
}

// Animation for shrinking back of pie slice so that it starts at the center of the canvas
function shrinkPieGraph(pieOptions) {
    const shrinkArea = Math.abs(pieOptions.grow); // Revert given value if negative
    const shrinkAngle = (pieOptions.endAngle - pieOptions.startAngle) / 2;
    const largeAngle = pieOptions.startAngle + shrinkAngle;
    const smallAngle = shrinkAngle < Math.PI / 2 ? Math.PI / 2 - shrinkAngle : shrinkAngle - Math.PI / 2;
    const shrinkXArea = shrinkArea * Math.cos(smallAngle);
    const shrinkYArea = shrinkArea * Math.sin(smallAngle);
    const shrinkXIncrement = shrinkXArea / (drawInterval * 0.1); // tenth of a second
    const shrinkYIncrement = shrinkYArea / (drawInterval * 0.1); // tenth of a second

    let newCenterX = pieOptions.centerX + shrinkXArea;
    let newCenterY = largeAngle < 2 * Math.PI ? pieOptions.centerY - shrinkYArea : pieOptions.centerY + shrinkYArea;

    const shrinkPieGraphAnimation = () => {
        const currentDistance = Math.sqrt(
            (newCenterX - pieOptions.centerX) ** 2 + (newCenterY - pieOptions.centerY) ** 2,
        );
        if (currentDistance > 0) {
            window.requestAnimationFrame(shrinkPieGraphAnimation);

            if (performance.now() > pieOptions.time + drawInterval) {
                const thisXIncrement = Math.min(shrinkXIncrement, Math.abs(newCenterX - pieOptions.centerX));
                const thisYIncrement = Math.min(shrinkYIncrement, Math.abs(newCenterY - pieOptions.centerY));
                newCenterX -= thisXIncrement;
                newCenterY -= largeAngle < 2 * Math.PI ? -thisYIncrement : thisYIncrement;
                drawPieGraph(
                    pieOptions.ctx,
                    pieOptions.centerX,
                    pieOptions.centerY,
                    newCenterX,
                    newCenterY,
                    pieOptions.startAngle,
                    pieOptions.endAngle,
                    pieOptions.donutColour,
                    pieOptions.sliceColour,
                    pieOptions.canvas,
                );
                pieOptions.time += drawInterval;
            }
        } else {
            currentlyAnimating = false;
        }
    };

    window.requestAnimationFrame(shrinkPieGraphAnimation);
}

// Draw pie graphs for diversification
export function drawDiversificationPieGraphs(pieGraphResults, pieGraphSection) {
    // Grab pie graphs canvases as elements
    if (!canadianStocksPieCanvas) canadianStocksPieCanvas = document.getElementById("canadian-stocks-pie");
    if (!worldStocksPieCanvas) worldStocksPieCanvas = document.getElementById("world-stocks-pie");
    if (!canadianSectorsPieCanvas) canadianSectorsPieCanvas = document.getElementById("canadian-sectors-pie");
    if (!worldSectorsPieCanvas) worldSectorsPieCanvas = document.getElementById("world-sectors-pie");

    // Setting width for future comparisons
    pieGraphContainerWidth = document.getElementsByClassName("pie-graph-container")[0].clientWidth;

    // Pasting results above graf
    $(".canada-stocks-share").html(pieGraphResults.canadaStocks.total.toFixed(1) + "%");
    $(".world-stocks-share").html(pieGraphResults.worldStocks.total.toFixed(1) + "%");
    $(".canada-sectors-share").html(pieGraphResults.canadaSectors.total.toFixed(1) + "%");
    $(".world-sectors-share").html(pieGraphResults.worldSectors.total.toFixed(1) + "%");

    // Stagger the building of pies
    if ($(".pie.stocks.selected")[0] && pieGraphSection === "stocks") {
        // This is for the diversification page rn, to prevent both graphs being built at the same time
        buildPieGraph(
            pieGraphResults.canadaStocks.total,
            canadianStocksPieCanvas,
            "#A9D4FF",
            "#016DFF",
            animateStocks,
            10,
        );
        buildPieGraph(pieGraphResults.worldStocks.total, worldStocksPieCanvas, "#829FEC", "#1E3784", animateStocks, 10);
        animateStocks = false;
        animateSectors = false;
    } else if ($(".pie.sectors.selected")[0] && pieGraphSection === "sectors") {
        buildPieGraph(
            pieGraphResults.canadaSectors.total,
            canadianSectorsPieCanvas,
            "#A9D4FF",
            "#016DFF",
            animateSectors,
            10,
        );
        buildPieGraph(
            pieGraphResults.worldSectors.total,
            worldSectorsPieCanvas,
            "#829FEC",
            "#1E3784",
            animateSectors,
            10,
        );
        animateStocks = false;
        animateSectors = false;
    } else {
        // This is for the index, all four graphs get built on open
        buildPieGraph(
            pieGraphResults.canadaStocks.total,
            canadianStocksPieCanvas,
            "#A9D4FF",
            "#016DFF",
            animateStocks,
            10,
        );
        buildPieGraph(pieGraphResults.worldStocks.total, worldStocksPieCanvas, "#829FEC", "#1E3784", animateStocks, 10);
        buildPieGraph(
            pieGraphResults.canadaSectors.total,
            canadianSectorsPieCanvas,
            "#A9D4FF",
            "#016DFF",
            animateSectors,
            10,
        );
        buildPieGraph(
            pieGraphResults.worldSectors.total,
            worldSectorsPieCanvas,
            "#829FEC",
            "#1E3784",
            animateSectors,
            10,
        );
        animateStocks = false;
        animateSectors = false;
    }
}

//Only redraw pie graphs if size of container changes, then reset width variable
export function pieGraphResize(pieGraphResults, pieGraphSection) {
    if (
        document.getElementsByClassName("pie-graph-container")[0] &&
        document.getElementsByClassName("pie-graph-container")[0].clientWidth !== pieGraphContainerWidth
    ) {
        drawDiversificationPieGraphs(pieGraphResults, pieGraphSection);
        pieGraphContainerWidth = document.getElementsByClassName("pie-graph-container")[0].clientWidth;
    }
}

//Build bar graf in canvas
export function buildDiversificationBarGraph(tableResults) {
    //Set width for future comparisons
    barGraphContainerWidth = document.getElementsByClassName("bar-graph-container")[0].clientWidth;

    const canvas = document.getElementById("diversification-bar-graph");
    canvas.width = canvas.parentNode.clientWidth;
    //Allow longer relative height for mobile
    canvas.height = canvas.width;

    //dimensions of graph inside canvas
    const graphWidth = canvas.width * 0.5,
        graphHeight = canvas.height * 0.7,
        paddingTop = canvas.height * 0.1,
        paddingLeft = canvas.width * 0.4,
        xRange = getXRange();
    console.log("xrange:", xRange);

    const ctx = canvas.getContext("2d");

    const drawLine = (ctx, startX, startY, endX, endY, color) => {
        ctx.save();
        ctx.strokeStyle = color;
        ctx.beginPath();
        ctx.moveTo(startX, startY);
        ctx.lineTo(endX, endY);
        ctx.stroke();
        ctx.restore();
    };

    const drawBar = (ctx, upperLeftCornerX, upperLeftCornerY, width, height, colour) => {
        ctx.save();
        ctx.fillStyle = colour;
        ctx.fillRect(upperLeftCornerX, upperLeftCornerY, width, height);
        ctx.restore();
    };

    function drawText(text, startX, startY, position, font, colour) {
        ctx.save();
        ctx.textAlign = position;
        ctx.fillStyle = colour;
        ctx.font = font;
        ctx.textBaseline = "middle";
        ctx.fillText(text, startX, startY);
        ctx.restore();
    }

    //Draw bars
    drawBars();

    //Draw y-axis
    drawLine(ctx, paddingLeft, paddingTop, paddingLeft, paddingTop + graphHeight, "black");
    //Draw y-axis
    drawLine(ctx, paddingLeft, paddingTop + graphHeight, paddingLeft + graphWidth, paddingTop + graphHeight, "black");
    //Draw ticks
    drawXTicks();

    //Function to get range of rates
    function getXRange() {
        const highestStock =
            Math.max(
                ...tableResults.map((stock) => {
                    return stock.tenYearAverage;
                }),
            ) * 100;
        let range = round5(highestStock);
        if (range - highestStock < 1.5) range += 5;
        console.log("RANGE?", range);
        return range;
    }

    //Draw ticks at bottom of graph, along with labels
    function drawXTicks() {
        const fontSize = canvas.width / 40;

        for (let i = 0; i <= xRange; i += 5) {
            const percentage = i / xRange;
            if (i !== 0 && i !== xRange) {
                drawLine(
                    ctx,
                    paddingLeft + percentage * graphWidth,
                    paddingTop + graphHeight - 5,
                    paddingLeft + percentage * graphWidth,
                    paddingTop + graphHeight,
                    "black",
                );
            }
            drawText(
                i + "%",
                paddingLeft + percentage * graphWidth,
                paddingTop + graphHeight + 15,
                "center",
                `normal ${fontSize}px Scotia`,
                "black",
            );
        }
    }

    //Draw bars of bar graph
    function drawBars() {
        const numberOfStocks = tableResults.length;
        const sectionHeight = (graphHeight - 15) / numberOfStocks;
        const sectionPadding = sectionHeight / 4;
        const barHeight = sectionHeight / 2;
        const fontSize = canvas.width / 27.5;

        let height = paddingTop; // will change in loop

        tableResults = tableResults[0].name === "Balanced Portfolio" ? tableResults.reverse() : tableResults;

        //Cycle through table results, determine length.
        tableResults.forEach((stock) => {
            let textColour, textWeight;
            drawBar(
                ctx,
                paddingLeft,
                height + sectionPadding,
                ((stock.tenYearAverage * 100) / xRange) * graphWidth,
                barHeight,
                stock.colour,
            );
            if (stock.name === "Balanced Portfolio") {
                textColour = stock.colour;
                textWeight = "normal";
            } else {
                textColour = "black";
                textWeight = "normal";
            }

            drawText(
                stock.name,
                canvas.width * 0.01,
                height + sectionPadding + barHeight / 2,
                "start",
                `${textWeight} ${fontSize}px Scotia`,
                textColour,
            );
            height = height + sectionHeight;
        });
    }

    //Round to the nearest 5
    function round5(x) {
        return x % 5 >= 2.5 ? parseInt(x / 5) * 5 + 5 : parseInt(x / 5) * 5;
    }
}

export function mouseenterPieGraphAnimation(results, pieGraphSection, pieGraphActive) {
    if (currentlyAnimating) {
        return;
    } else if ($(".pie.stocks.selected")[0] && pieGraphSection === "stocks") {
        if (pieGraphActive === "canadianStocks") {
            buildPieGraph(
                results.canadaStocks.total,
                canadianStocksPieCanvas,
                "#A9D4FF",
                "#016DFF",
                false,
                5,
                "mouseenter",
            );
        } else {
            buildPieGraph(
                results.worldStocks.total,
                worldStocksPieCanvas,
                "#829FEC",
                "#1E3784",
                false,
                5,
                "mouseenter",
            );
        }
    } else if ($(".pie.sectors.selected")[0] && pieGraphSection === "sectors") {
        if (pieGraphActive === "canadianSectors") {
            buildPieGraph(
                results.canadaSectors.total,
                canadianSectorsPieCanvas,
                "#A9D4FF",
                "#016DFF",
                false,
                5,
                "mouseenter",
            );
        } else {
            buildPieGraph(
                results.worldSectors.total,
                worldSectorsPieCanvas,
                "#829FEC",
                "#1E3784",
                false,
                5,
                "mouseenter",
            );
        }
    } else {
        buildPieGraph(
            results.canadaStocks.total,
            canadianStocksPieCanvas,
            "#A9D4FF",
            "#016DFF",
            false,
            5,
            "mouseenter",
        );
        buildPieGraph(results.worldStocks.total, worldStocksPieCanvas, "#829FEC", "#1E3784", false, 5, "mouseenter");
        buildPieGraph(
            results.canadaSectors.total,
            canadianSectorsPieCanvas,
            "#A9D4FF",
            "#016DFF",
            false,
            5,
            "mouseenter",
        );
        buildPieGraph(results.worldSectors.total, worldSectorsPieCanvas, "#829FEC", "#1E3784", false, 5, "mouseenter");
    }
}

export function mouseleavePieGraphAnimation(results, pieGraphSection, pieGraphActive) {
    if (currentlyAnimating) {
        return;
    } else if ($(".pie.stocks.selected")[0] && pieGraphSection === "stocks") {
        if (pieGraphActive === "canadianStocks") {
            buildPieGraph(
                results.canadaStocks.total,
                canadianStocksPieCanvas,
                "#A9D4FF",
                "#016DFF",
                false,
                5,
                "mouseleave",
            );
        } else {
            buildPieGraph(
                results.worldStocks.total,
                worldStocksPieCanvas,
                "#829FEC",
                "#1E3784",
                false,
                5,
                "mouseleave",
            );
        }
    } else if ($(".pie.sectors.selected")[0] && pieGraphSection === "sectors") {
        if (pieGraphActive === "canadianSectors") {
            buildPieGraph(
                results.canadaSectors.total,
                canadianSectorsPieCanvas,
                "#A9D4FF",
                "#016DFF",
                false,
                5,
                "mouseleave",
            );
        } else {
            buildPieGraph(
                results.worldSectors.total,
                worldSectorsPieCanvas,
                "#829FEC",
                "#1E3784",
                false,
                5,
                "mouseleave",
            );
        }
    } else {
        buildPieGraph(
            results.canadaStocks.total,
            canadianStocksPieCanvas,
            "#A9D4FF",
            "#016DFF",
            false,
            5,
            "mouseleave",
        );
        buildPieGraph(results.worldStocks.total, worldStocksPieCanvas, "#829FEC", "#1E3784", false, 5, "mouseleave");
        buildPieGraph(
            results.canadaSectors.total,
            canadianSectorsPieCanvas,
            "#A9D4FF",
            "#016DFF",
            false,
            5,
            "mouseleave",
        );
        buildPieGraph(results.worldSectors.total, worldSectorsPieCanvas, "#829FEC", "#1E3784", false, 5, "mouseleave");
    }
}

//Only rebuild if width of canvas changes
export function barGraphResize(tableResults) {
    if (
        document.getElementsByClassName("bar-graph-container")[0] &&
        document.getElementsByClassName("bar-graph-container")[0].clientWidth !== barGraphContainerWidth
    ) {
        buildDiversificationBarGraph(tableResults);
        console.log("WHY??");
    }
}
